import request from '../request'

export default {
  getParametros() {
    return request.get('parametro')
  },

  setParametro(data) {
    return request.put(`parametro`, data)
  }
}
